import { imageUtils } from "@/business/shared/commons/imageUtils/imageUtils";

export interface CampaignCreateRequest {
  campaignName: string;
  image: File;
  image1: File | null;
  image2: File | null;
}

export interface CampaignEditRequest {
  campaignName: string;
  image: File | null;
  image1: File | null;
  image2: File | null;
}

export interface Campaign {
  campaignName: string;
  icon: string;
  additional_image1: string | null;
  additional_image2: string | null;
}

export function CampaignActions() {
  function createCampaignRequest(
    campaignName: string,
    image: File,
    image1: File | null,
    image2: File | null
  ): CampaignCreateRequest {
    return {
      campaignName: campaignName,
      image: image,
      image1: image1,
      image2: image2,
    };
  }

  function editCampaignRequest(
    campaignName: string,
    image: File | null,
    image1: File | null,
    image2: File | null
  ): CampaignEditRequest {
    return {
      campaignName: campaignName,
      image: image,
      image1: image1,
      image2: image2,
    };
  }

  function infoCampaign(
    campaignName: string,
    icon: string,
    additional_image1: string | null,
    additional_image2: string | null
  ): Campaign {
    return {
      campaignName: campaignName,
      icon: icon,
      additional_image1: additional_image1,
      additional_image2: additional_image2,
    };
  }

  function deserialize(object: string): Campaign[] {
    const parseResponse = JSON.parse(JSON.stringify(object));
    return parseResponse.map((campaign: Campaign) => {
      return infoCampaign(
        campaign.campaignName,
        imageUtils.putTimeStamp(campaign.icon),
        imageUtils.putTimeStamp(campaign.additional_image1),
        imageUtils.putTimeStamp(campaign.additional_image2)
      );
    });
  }

  return {
    createCampaignRequest,
    editCampaignRequest,
    deserialize,
  };
}
